import { Component, OnInit } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { EventsService } from "../../events/event.service";
import { NgSelectModule } from "@ng-select/ng-select";
import { CollectionService } from "../../collections/collection.service";

@Component({
  selector: "app-valid-coupon-modal",
  standalone: true,
  imports: [TranslateModule, ReactiveFormsModule, FormsModule, NgSelectModule],
  templateUrl: "./valid-coupon.component.html",
  styleUrl: "./valid-coupon.component.scss",
})
export class ValidCouponModalComponent implements OnInit {
  userId: number = 0;
  isLoading = false;
  isLoadingProject = false;
  couponCode: string = "";
  userData: any = {};
  couponInfo: FormGroup;
  salesOptions: any = [];
  inputsDisabled = true;
  um = [
    { id: 1, name: this.translateService.instant("ums.pcs") },
    { id: 2, name: this.translateService.instant("ums.sqm") },
    { id: 3, name: this.translateService.instant("ums.lm") },
  ];

  professionOptions = [
    {
      id: "Privato",
      name: "Частное лицо",
    },
    {
      id: "Architetto – Designen",
      name: "Архитектор - дизайнер",
    },
    {
      id: "Investitore",
      name: "Инвестор",
    },
    {
      id: "Paesaggista",
      name: "Ландшафтный дизайнер",
    },
    {
      id: "Impresa edile – Azienda di posa piastrelle",
      name: "Строительная компания - Компания по укладке плитки",
    },
  ];
  constructor(
    private translateService: TranslateService,
    private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private eventService: EventsService,
    private collectionService: CollectionService,
  ) {}

  ngOnInit(): void {
    this.isLoadingProject = true;
    this.initForm();
    this.getProductsOptions();
    if (this.salesFormArray.length === 0) {
      this.addNewProduct();
    }
  }

  get isFormValid(): boolean {
    // Tutti i gruppi devono avere code e quantity validi
    return this.salesFormArray.controls.every((group) => {
      const code = group.get("code")?.value;
      let quantity = group.get("quantity")?.value;
      if (typeof quantity === "string") {
        quantity = quantity.replace(",", ".");
      }

      return code && quantity > 0;
    });
  }

  initForm() {
    this.couponInfo = this.fb.group({
      // name: [this.userData.name, Validators.required],
      // surname: [this.userData.surname, Validators.required],
      // phone: [this.userData.phone, Validators.required],
      // city: [this.userData.city, Validators.required],
      // profession: [this.userData.profession, Validators.required],
      // email: [this.userData.email, [Validators.required, Validators.email]],
      sales: this.fb.array([], [this.uniqueProductCodeValidator()]),
    });
  }

  quantityValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      // Accetta stringhe con numeri e virgola
      if (value === null || value === undefined || value === "") {
        return { required: true };
      }

      // Converti la virgola in punto per il controllo numerico
      const numericValue = parseFloat(value.toString().replace(",", "."));

      if (isNaN(numericValue)) {
        return { notANumber: true };
      }

      if (numericValue <= 0) {
        return { notGreaterThanZero: true };
      }

      return null;
    };
  }

  getProductsOptions() {
    this.collectionService.getProducts().subscribe({
      next: (response: any) => {
        if (response.success) {
          this.salesOptions = response.data.map((product: any) => ({
            id: product.id,
            name: product.name,
            unit: product.uom,
            code: product.code,
          }));
        }
        console.log(this.salesOptions);

        this.isLoadingProject = false;
      },
      error: (error: any) => {
        this.isLoadingProject = false;
      },
    });
  }

  get salesFormArray(): FormArray {
    return this.couponInfo.get("sales") as FormArray;
  }

  // Create a new FormGroup for a single sale item
  createSaleFormGroup(): FormGroup {
    return this.fb.group({
      id: [null],
      quantity: [null, [Validators.required, this.quantityValidator()]],
      unit: [""],
      code: ["", Validators.required],
    });
  }

  addNewProduct() {
    this.salesFormArray.push(this.createSaleFormGroup());
  }

  removeSale(index: number) {
    let optionCodeRemoved = this.salesFormArray.at(index)?.get("code")?.value;
    this.salesFormArray.removeAt(index);
    this.salesOptions.forEach((element: any) => {
      if (optionCodeRemoved === element.code) {
        element["disabled"] = false;
      }
    });
  }

  onOptionSelected(event: any) {
    this.salesOptions.forEach((element: any) => {
      if (event.code === element.code) {
        element["disabled"] = true;
      }
    });
  }

  saveCouponInfo() {
    const payload = {
      id: this.userData.id,
      // name: this.couponInfo.value.name,
      // surname: this.couponInfo.value.surname,
      // email: this.couponInfo.value.email,
      // phone: this.couponInfo.value.phone,
      // profession: this.couponInfo.value.profession,
      // city: this.couponInfo.value.city,
      coupon: this.couponCode,
      products: this.couponInfo.value.sales.map((sale: any) => {
        const product = this.salesOptions.find(
          (opt: any) => opt.code === sale.code,
        );
        let quantity = sale.quantity;
        if (typeof quantity === "string") {
          quantity = quantity.replace(",", ".");
        }

        return {
          code: product?.code ?? "",
          quantity: quantity,
        };
      }),
    };
    this.collectionService.activateCoupon(payload).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.eventService.emitEvent("refreshCustomer");
          const success = this.translateService.instant("success.user_saved");
          this.activeModal.close(this.couponInfo.value);
          this.toastrService.success(success, "", {
            positionClass: "toast-bottom-left",
            tapToDismiss: true,
          });
        }
      },
    });
  }

  close() {
    this.activeModal.dismiss();
  }

  onQuantityInput(event: any, control: AbstractControl | null) {
    if (!control) return;

    let inputValue = event.target.value;

    // Consenti solo cifre e una virgola
    const validPattern = /^\d*(,\d*)?$/;
    if (!validPattern.test(inputValue)) {
      inputValue = inputValue.slice(0, -1);
    }

    // Aggiorna il campo visivo
    event.target.value = inputValue;

    // Non modificare FormControl qui: lasciamo il validator gestire la conversione
    control.setValue(inputValue, { emitEvent: false });
  }

  greaterThanZeroValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      // Check if the value is a valid number
      if (value === null || value === undefined || isNaN(value)) {
        return { notANumber: true };
      }

      // Check if the value is greater than 0
      if (Number(value) <= 0) {
        return { notGreaterThanZero: true };
      }

      return null;
    };
  }

  uniqueProductCodeValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const formArray = control as FormArray;
      const codes: string[] = [];
      let isDuplicate = false;

      // Iterate through all FormGroups (sales) in the FormArray
      for (const group of formArray.controls) {
        const codeControl = group.get("code");

        if (codeControl && codeControl.value) {
          const code = codeControl.value;

          // Check for duplicates
          if (codes.includes(code)) {
            isDuplicate = true;
            break; // Found a duplicate, no need to continue
          }

          codes.push(code);
        }
      }

      // Return the error object if duplicates are found
      if (isDuplicate) {
        return { duplicateProductCode: true };
      }

      return null; // No errors
    };
  }
}
